import axios from "axios";
import {host} from "../config/api";

export const getIngredients = ({searchText}) => {
    return  axios({
        url: `${host}/v1/ingredients`,
        method: 'GET',
        params: {
            "search-text": searchText,
        },
    })
}

export const setStarred = (ingredientId, ingredientType, isStarred) => {
    return axios({
        method: 'post',
        url: `${host}/v1/ingredients/set-starred`,
        data: {
          ingredient : {
              id: ingredientId
          },
          ingredient_type : ingredientType,
          is_starred : isStarred
        }
    })
}

export const IngredientType = {
    NUTRIKATOR: "NUTRIKATOR",
    EUROFIR: "EUROFIR"
}